import { render, staticRenderFns } from "./WapWXCW01Setting.vue?vue&type=template&id=6055bec9&scoped=true&"
import script from "./WapWXCW01Setting.vue?vue&type=script&lang=js&"
export * from "./WapWXCW01Setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055bec9",
  null
  
)

export default component.exports